import { getAuthHeaders } from '../utils/authHeaders';

const API_URL = 'https://app.pvslimited.co.uk/api';

export async function fetchBumpTestStatus() {
  const response = await fetch(`${API_URL}/bump-test/status`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Failed to load bump test status.');
  }

  return response.json();
}

export default fetchBumpTestStatus;
